export interface PeriodChange {
  delta: number;
  deltaPercent: number;
}

export const toNumber = (value?: number | string): number => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }

  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  return 0;
};

export const formatInteger = (value: number): string => value.toLocaleString('en-US');

export const formatSignedInteger = (value: number): string => {
  if (!Number.isFinite(value) || value === 0) {
    return formatInteger(0);
  }
  const formatted = formatInteger(Math.abs(value));
  return value > 0 ? `+${formatted}` : `-${formatted}`;
};

export const formatSignedPercent = (value: number, fractionDigits = 1): string => {
  if (!Number.isFinite(value) || value === 0) {
    return `${(0).toFixed(fractionDigits)}%`;
  }
  const formatted = Math.abs(value).toFixed(fractionDigits);
  return value > 0 ? `+${formatted}%` : `-${formatted}%`;
};

export const buildPeriodChange = (currentTotal: number, previousTotal: number): PeriodChange => {
  const delta = currentTotal - previousTotal;
  const deltaPercent = previousTotal > 0 ? (delta / previousTotal) * 100 : 0;
  return { delta, deltaPercent };
};
